import { Button, DatePicker, Select, Space } from "antd";
import { ColumnsType } from "antd/es/table";
import UploadIcon from "../../../assets/icons/UploadIcon";
import CustomTable from "../../../components/common/CustomTable";
import IconButton from "../../../components/common/IconButton";
import Subheader from "../../../components/ui/Subheader";
import { addKeyInArray, selectSearchOption } from "../../../helpers/siteConfig";
import useModal from "../../../hooks/useModal";
import useTable from "../../../hooks/useTable";
import AdminLayout from "../../../layouts/AdminLayout";
import { AddZero, countParPageSerialNumber } from "../../../utils/number";
import ImportExcel from "./_components/ImportExcel";
import FilterIcon from "../../../assets/icons/FilterIcon";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import {
  GetAllPOData,
  GetALLPOParams,
  PurchaseOrder,
} from "../../../types/redux/NP/supplier";
import { useCallback, useEffect, useState } from "react";
import { getAllPOAsync } from "../../../store/features/NP/supplier/supplierAPI";
import { formatDate, formattedPrice } from "../../../utils/time";
import Loader from "../../../components/common/Loader";
import { Moment } from "moment";
import { Dayjs } from "dayjs";

export default function POManagerList() {
  const [selectedMonth, setSelectedMonth] = useState<Dayjs | null>(null);
  const { page, limit, handlePagination } = useTable();
  const { open, toggle, handleOpen } = useModal();
  const dispatch = useAppDispatch();

  const { loading, allPO, pagination } = useAppSelector(
    (state) => state.supplier
  );

  const poData = useCallback(() => {
    const params: GetALLPOParams = {
      zone: "",
      month: selectedMonth ? selectedMonth.month() + 1 : "",
      year: selectedMonth ? selectedMonth.year() : "",
      limit: limit,
      skip: limit * (page - 1),
    };

    dispatch(
      getAllPOAsync({
        params: params,
      })
    );
  }, [dispatch, page, limit, selectedMonth]);

  useEffect(() => {
    poData();
  }, [poData]);

  const reRender = () => {
    toggle();
    poData();
  };

  const columns: ColumnsType<PurchaseOrder> = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => countParPageSerialNumber(page, limit, index),
    },

    {
      title: "Vendor Name",
      dataIndex: "vendor",
      render: (val) => {
        return (
          <>
            <div>{val?.fullName ? val?.fullName : "N/A"}</div>
          </>
        );
      },
    },

    {
      title: (
        <div className="flex items-center justify-center gap-3">
          <span>PO Number</span>
          <span className="cursor-pointer mt-2">
            <FilterIcon />
          </span>
        </div>
      ),
      align: "center",
      dataIndex: "PONumber",
      render: (val) => {
        return (
          <>
            <div>{val ? val : "N/A"}</div>
          </>
        );
      },
    },

    {
      title: "PO Issue Date",
      dataIndex: "POIssuanceDate",
      align: "center",
      render: (val) => {
        return (
          <>
            <div>{val ? formatDate(val) : "N/A"}</div>
          </>
        );
      },
    },

    {
      title: "PO Expire Date",
      dataIndex: "poExpireDate",
      align: "center",
      render: (val) => {
        return (
          <>
            <div>{val ? formatDate(val) : "N/A"}</div>
          </>
        );
      },
    },

    {
      title: "Payment Term [Days]",
      dataIndex: "paymentTermDays",
      align: "center",
      render: (val) => {
        return (
          <>
            <div>{val ? val : "N/A"}</div>
          </>
        );
      },
    },

    {
      title: "Contact Name",
      dataIndex: "contactName",
      align: "center",
      render: (val) => {
        return (
          <>
            <div>{val ? val : "N/A"}</div>
          </>
        );
      },
    },

    {
      title: "Contact Number",
      dataIndex: "contactNumber",
      align: "center",
      render: (val) => {
        return (
          <>
            <div>{val ? val : "N/A"}</div>
          </>
        );
      },
    },

    {
      title: "Line 1 Item Code",
      dataIndex: "lineOneItemCode",
      align: "center",
      render: (val) => {
        return <div>{val ? val : "N/A"}</div>;
      },
      onHeaderCell: () => {
        return {
          className: "custom_edotco_tableRed",
        };
      },
    },

    // {
    //   title: "PG_Valid TT Delivery Lead Time",
    //   dataIndex: "pgValidTTDeliveryTime",
    //   align: "center",
    //   render: (val) => {
    //     return <div>{val ? formatDate(val) : "N/A"}</div>;
    //   },
    //   onHeaderCell: () => {
    //     return {
    //       className: "custom_edotco_tableRed",
    //     };
    //   },
    // },

    // {
    //   title: "PG_Valid TT QTY",
    //   dataIndex: "pgValidTTQty",
    //   align: "center",
    //   render: (val) => {
    //     return <div>{val ? val : "N/A"}</div>;
    //   },
    //   onHeaderCell: () => {
    //     return {
    //       className: "custom_edotco_tableRed",
    //     };
    //   },
    // },

    // {
    //   title: "PG_Valid TT UOM",
    //   dataIndex: "pgValidTTUOM",
    //   align: "center",
    //   render: (val) => {
    //     return <div>{val ? val : "N/A"}</div>;
    //   },
    //   onHeaderCell: () => {
    //     return {
    //       className: "custom_edotco_tableRed",
    //     };
    //   },
    // },

    {
      title: "PG_Valid TT Unit Price [BDT]",
      dataIndex: "pgValidTTIOneUnitPrice",
      align: "center",
      render: (val) => {
        return <div>{val ? formattedPrice(val) : "N/A"}</div>;
      },
      onHeaderCell: () => {
        return {
          className: "custom_edotco_tableRed",
        };
      },
    },

    {
      title: "Line 2 Item Code",
      dataIndex: "lineTwoItemCode",
      align: "center",
      render: (val) => {
        return <div>{val ? val : "N/A"}</div>;
      },
      onHeaderCell: () => {
        return {
          className: "custom_edotco_tableGreen",
        };
      },
    },

    // {
    //   title: "PG_PGRH Delivery Lead Time",
    //   dataIndex: "pgRunDeliveryTIme",
    //   align: "center",
    //   render: (val) => {
    //     return <div>{val ? formatDate(val) : "N/A"}</div>;
    //   },
    //   onHeaderCell: () => {
    //     return {
    //       className: "custom_edotco_tableGreen",
    //     };
    //   },
    // },

    // {
    //   title: "PG_PGRH QTY",
    //   dataIndex: "pgHty",
    //   align: "center",
    //   render: (val) => {
    //     return <div>{val ? val : "N/A"}</div>;
    //   },
    //   onHeaderCell: () => {
    //     return {
    //       className: "custom_edotco_tableGreen",
    //     };
    //   },
    // },

    // {
    //   title: "PG_PGRH UOM",
    //   dataIndex: "pgRunUom",
    //   align: "center",
    //   render: (val) => {
    //     return <div>{val ? val : "N/A"}</div>;
    //   },
    //   onHeaderCell: () => {
    //     return {
    //       className: "custom_edotco_tableGreen",
    //     };
    //   },
    // },

    {
      title: "PG_PGRH Unit Price [BDT]",
      dataIndex: "pgRunHourUnitPrice",
      align: "center",
      render: (val) => {
        return <div>{val ? formattedPrice(val) : "N/A"}</div>;
      },
      onHeaderCell: () => {
        return {
          className: "custom_edotco_tableGreen",
        };
      },
    },

    {
      title: "Total Amount",
      dataIndex: "totalAmount",
      align: "center",
      render: (val) => {
        return (
          <>
            <div>{val ? formattedPrice(val) : "N/A"}</div>
          </>
        );
      },
    },

    {
      title: "VAT [%]",
      dataIndex: "vat",
      align: "center",
      render: (val) => {
        return (
          <>
            <div>{val ? val : "N/A"}</div>
          </>
        );
      },
    },

    {
      title: "Total with VAT",
      dataIndex: "totalWithVat",
      align: "center",
      render: (val) => {
        return (
          <>
            <div>{val ? formattedPrice(val) : "N/A"}</div>
          </>
        );
      },
    },
  ];

  return (
    <AdminLayout title="PO" headerTitle="PO">
      {open?.type === "IMPORT" && (
        <ImportExcel
          open={open.open}
          // data={open?.data}
          handleClose={toggle}
          reRender={reRender}
        />
      )}

      <section className="mt-7">
        <Subheader
          title="PO List"
          subTitle={`Total PO: ${pagination?.totalRecords || 0} `}
          subTitleClass="!text-primary"
        >
          <Space size="middle">
            {/* <Button className="!text-white !bg-[#8897AE] !border-[#8897AE] !px-6">
              Filter
            </Button> */}
            <DatePicker
              picker="month"
              format="MMMM"
              onChange={(date) => {
                setSelectedMonth(date);
              }}
            />
            <IconButton
              type="primary"
              nextIcon={<UploadIcon />}
              onClick={() =>
                handleOpen({
                  type: "IMPORT",
                })
              }
            >
              Import Excel
            </IconButton>
          </Space>
        </Subheader>

        {loading ? (
          <Loader />
        ) : (
          <CustomTable
            loading={false}
            total={pagination?.totalRecords}
            page={pagination?.currentPage}
            limit={pagination?.limit}
            handlePagination={handlePagination}
            columns={columns}
            dataList={addKeyInArray(allPO)}
            className="po_manager_table"
            // isPagination={keyword ? false : true}
          />
        )}
      </section>
    </AdminLayout>
  );
}
